(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "prop-types", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("prop-types"), require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.propTypes, global.react);
    global.BaseField = mod.exports;
  }
})(this, function (_exports, _propTypes, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports["default"] = void 0;
  _propTypes = _interopRequireDefault(_propTypes);
  _react = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

  var FormValueScopeContext = _react["default"].createContext();

  var _default = {
    propTypes: {
      name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
    },
    contextType: FormValueScopeContext
  };
  _exports["default"] = _default;
});